'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('./constants');
var _LandingSliderPhoto = require('./LandingSliderPhoto.scss');var style = _interopRequireWildcard(_LandingSliderPhoto);
var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var swiperParams = {
  speed: 500,
  slidesPerView: 4,
  centeredSlides: true,
  loop: true,
  slidesPerGroupAuto: true,
  spaceBetween: 30,
  breakpoints: {
    1600: {
      slidesPerView: 3.5 },

    1370: {
      slidesPerView: 2.5 },

    1000: {
      slidesPerView: 1.5 } } };




var swiperMobileParams = {
  speed: 500,
  centeredSlides: true,
  slidesPerGroupAuto: true,
  spaceBetween: 30,
  loop: true };var


LandingSliderPhoto = function (_Component) {_inherits(LandingSliderPhoto, _Component);
  function LandingSliderPhoto(props) {_classCallCheck(this, LandingSliderPhoto);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.





    setRef = function (ref) {
      _this.swiperRef = ref ? ref.swiper : null;
    };_this.

    mappedItems = function (item) {return (
        _react2.default.createElement('div', { className: style.sliderWrapper },
          _react2.default.createElement('img', { src: item, alt: 'realtor' })));};_this.



    next = function () {
      if (_this.swiperRef) {
        _this.swiperRef.slideNext();
      }

      _this.setState(function (prevState) {return {
          activeSlideIndex: prevState.activeSlideIndex < _constants.CONSTANTS_COMMENTS.length - 1 ?
          prevState.activeSlideIndex + 1 :
          0 };});

    };_this.

    previous = function () {
      if (_this.swiperRef) {
        _this.swiperRef.slidePrev();
      }

      _this.setState(function (prevState) {return {
          activeSlideIndex: prevState.activeSlideIndex > 0 ?
          prevState.activeSlideIndex - 1 :
          _constants.CONSTANTS_COMMENTS.length - 1 };});

    };_this.state = { activeSlideIndex: 0 };return _this;}LandingSliderPhoto.prototype.

  render = function render() {
    var params = !this.props.isMobile ? swiperParams : swiperMobileParams;

    return (
      _react2.default.createElement('div', { className: style.containerSlider },
        _react2.default.createElement('img', {
          src: _RealtorLanding2.default.prevArrow,
          className: style.arrowDesktop,
          onClick: this.previous,
          alt: '' }),

        _react2.default.createElement('div', { className: style.slicSlider },
          _react2.default.createElement(_reactIdSwiper2.default, _extends({}, params, { ref: this.setRef }),
            _constants.CONSTANTS_COMMENTS.map(this.mappedItems))),


        _react2.default.createElement('img', {
          src: _RealtorLanding2.default.nextArrow,
          className: style.arrowDesktop,
          onClick: this.next,
          alt: '' }),

        _react2.default.createElement('div', { className: style.buttonWrapper },
          _react2.default.createElement('img', { src: _RealtorLanding2.default.prevArrow, onClick: this.previous, alt: '' }),
          _react2.default.createElement('img', { src: _RealtorLanding2.default.nextArrow, onClick: this.next, alt: '' }))));



  };return LandingSliderPhoto;}(_react.Component);


LandingSliderPhoto.propTypes = {
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool };exports.default =


LandingSliderPhoto;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingSliderPhoto/LandingSliderPhoto.js
// module id = 2704
// module chunks = 0